if (document.querySelectorAll("#landing-intro-lottie").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("landing-intro-lottie"), // Required
    path: "assets/animations/landing.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "Landing-intro",
  });
}

// Disable for Mobile
if (window.screen.width > 640) {
  if (document.querySelectorAll("#sdgs-intro-lottie").length) {
    window.bodymovin.loadAnimation({
      container: document.getElementById("sdgs-intro-lottie"), // Required
      path: "assets/animations/sdgs.json", // Required
      renderer: "canvas", // Required
      loop: true,
      autoplay: true,
      name: "sdgs-intro",
    });
  }
}

window.addEventListener("load", function () {
  if ($(".stories-carousel").length > 0) {
    $(".stories-carousel")
      .slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        focusOnSelect: true,
        prevArrow: $(".stories-carousel__prev-arrow"),
        nextArrow: $(".stories-carousel__next-arrow"),
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              dots: true,
              infinite: true,
            },
          },
        ],
      })
      .removeClass("opacity-0");
  }
});
